/**
 * Directive: posTile
 */
angular.module('acme.common.directive.posTile', [
  'ang-drag-drop',
  'acme.common.service.helpers',
  'acme.common.service.posConfig'
])
.directive('posTile', [ '$filter', 'HelpersService', 'PosConfigService', function($filter, HelpersService, PosConfigService) {

  return {
    restrict: 'A',
    templateUrl: 'common/directives/pos/tile/tile.tpl.html',

    scope: {
      silent: '@',
      dragDropChannel: '@',
      available: '=',
      model: '=',
      validate: '='
    },

    link: function($scope, $element, $attrs) {},

    controller: ['$scope', function($scope) {
      
      $scope.posTile = {

        color: '',
        channel: 'tile',

        init: function() {
          var presaleDateSplit;

          if ($scope.model && $scope.model.presell) {
            $scope.model.date = PosConfigService.presellDateToTileDate($scope.model.presell.date);
          }
          $scope.$watch('model.presell', this.onModelPresellDateUpdate);

          if ($scope.model.color) {
            this.color = PosConfigService.tiles.colorToRgba($scope.model);
            $scope.$watch('model.color', this.onModelColorUpdate);
          }

          if ($scope.dragDropChannel) {
            this.channel = $scope.dragDropChannel;
          }

          if ($scope.validate && typeof $scope.validate === 'function') {
            $scope.validate($scope.model);
          }
        },

        select: function() {
          if ($scope.model) {
            if ($scope.model.isEmpty) {
              $scope.model.isEmpty = false;
            } else {
              //$scope.model.isEmpty = true;
              //$scope.$emit('PosTile::Remove', $scope.model);
            }
            if (!$scope.silent) {
              $scope.$emit('PosTile::Select', $scope.model);
            }
          }
        },

        onModelPresellDateUpdate: function(n, o) {
          if (n && n.date) {
            $scope.model.date = PosConfigService.presellDateToTileDate(n.date);
          }else{
            $scope.model.date = '';
          }
        },

        onModelColorUpdate: function(n, o) {
          $scope.posTile.color = PosConfigService.tiles.colorToRgba($scope.model);
        },

        onDrop: function(target, source) {
          if (!$scope.silent) {
            if ($scope.model.isEmpty) {
              // place and update tile position
              $scope.$emit('PosTile::Move', {
                source: source,
                target: target
              });
            } else {
              // swap tile
              $scope.$emit('PosTile::Swap', {
                source: source,
                target: target
              });
            }
          }
        },

        dropValidate: function(target, source) {

          return (target !== source);
        },

        isUnavailable: function() {
          return ($scope.available === false || $scope.available === 'false' || $scope.model.hasError);
        }

      };

      $scope.posTile.init();
    }]

  };

}]);